import { Component, EventEmitter, Input, Output } from '@angular/core';
import moment from 'moment';

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: '[msd-notification-cell]',
  templateUrl: './notification-cell.component.html',
  styleUrls: ['./notification-cell.component.scss'],
})
export class NotificationCellComponent {
  @Input() title: string;
  @Input() content: string;
  @Input() date: Date;
  @Input() loading = false;
  @Input() additionalButton: string | undefined;
  @Input() additionalPayload: { [key: string]: string | null };

  @Output() onMarkAsRead = new EventEmitter<void>();
  @Output() onAdditionalButton = new EventEmitter<{
    [key: string]: string | null;
  }>();

  constructor() {
    // nothing
  }

  markAsRead() {
    this.onMarkAsRead?.emit();
  }

  public get formattedDate() {
    return moment(this.date).format('DD.MM.yyyy à HH:mm');
  }

  public get isMarkAsReadButtonVisible(): boolean {
    return this.onMarkAsRead.observed;
  }

  doAdditionalButton() {
    this.onAdditionalButton.emit(this.additionalPayload);
  }
}
